import K from "./constants";
import restHelpers from "../helpers/restHelper";

const getServiceTypes = plate => restHelpers.withBearer.get(`${K.API_URL}/api/v2/infocar/intervalli/by-plate/${plate}`, {});

const getSequences = linkId => restHelpers.withBearer.get(`${K.API_URL}/api/v2/infocar/intervalli/${linkId}`, {});

export default {
  getServiceTypes,
  getSequences
};



// WEBPACK FOOTER //
// ./src/services/servicing.js